import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h2 className="mt-6 text-center text-6xl font-extrabold text-gray-900">404</h2>
          <p className="mt-2 text-center text-3xl font-bold text-gray-900">{t('common.pageNotFound')}</p>
          <p className="mt-2 text-center text-sm text-gray-600">
            {t('common.pageNotFoundDescription')}
          </p>
        </div>
        <div className="mt-8">
          <Link
            to="/"
            className="btn btn-primary w-full"
          >
            {t('common.backToHome')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
